<template>
  <v-dialog v-model="internalValue" :width="width" @click:outside="cancel">
    <v-card>
      <v-card-title primary-title>{{ title }}</v-card-title>

      <v-card-text style="padding-top: 20px">
        <slot>
          {{ body }}
        </slot>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
            @click="cancel"
            class="text-none"
            depressed
            large
            outlined
        >{{ cancelText }}
        </v-btn
        >
        <v-btn
            :color="confirmColor"
            class="text-none"
            @click="confirm"
            depressed
            large
        >{{ confirmText }}
        </v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    value: {type: Boolean, default: false},
    title: {type: String, default: "Jeste li sigurni?"},
    body: {type: String, default: ""},
    confirmText: {type: String, default: "Potvrdi"},
    cancelText: {type: String, default: "Odustani"},
    confirmColor: {type: String, default: "error"},
    width: {type: [String, Number], default: 500},
  },
  computed: {
    internalValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  methods: {
    confirm() {
      this.$emit("confirm");
    },
    cancel() {
      this.$emit("cancel");
      this.$emit("input", false);
    },
  },
};
</script>
